var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isGranted('DELETE_USER', _vm.id))?_c('q-btn',{attrs:{"color":"negative","size":"sm","icon":"fa fa-trash","flat":""},on:{"click":_vm.open}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }